import { useCallback, useEffect, useState } from "react";
import {
  getTournamentEnabledSports,
  listSports,
} from "../api/sportsManagement/sportsService";
import { Sport } from "../api/sportsManagement/types";

export interface SportOption {
  value: string;
  label: string;
  sport: Sport;
}

export function useTournamentSports() {
  const [sports, setSports] = useState<Sport[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      setSports(getTournamentEnabledSports(await listSports()));
      setError(null);
    } catch (reason: any) {
      setError(reason?.message || "Unable to load available sports.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    sports,
    options: sports.map((sport) => ({ value: sport.name, label: sport.name, sport })),
    loading,
    error,
    refresh,
  };
}
